















import Vue from "vue";

export default Vue.extend({
  name: "FilterHeadTag",
  props: {
    label: {
      type: String,
      required: true,
    },
    clickFunction: {
      type: Function,
      required: true,
    },
  },
});
